import { ChainId } from '../config/networks';
/**
 * Checks if the given network is an EVM (Ethereum Virtual Machine) compatible network.
 *
 * @param network - The network identifier to check.
 * @returns `true` if the network is an EVM network, otherwise `false`.
 */
export const isEVMNetwork = (network) => {
    return !(network == ChainId.SOLANA ||
        network == ChainId.SOLANA_DLN ||
        network == ChainId.SOLANA_OKX);
};
